import type { RootState } from '@/store/root-reducer';

const selectAddFundraising = (state: RootState) => state.addFundraising;

export const selectDraft = (state: RootState) => selectAddFundraising(state).draft;
export const selectSaveStatus = (state: RootState) => selectAddFundraising(state).saveStatus;
export const selectError = (state: RootState) => selectAddFundraising(state).error;
export const selectValidationErrors = (state: RootState) =>
  selectAddFundraising(state).validationErrors;

export const selectCreated = (state: RootState) => selectAddFundraising(state).created;

export const selectIsSaving = (state: RootState) =>
  selectAddFundraising(state).saveStatus === 'saving';
